(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["capilla-dynamic-page"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cfp]');
  if (!root) return;

  var DEFAULTS = {
    cps: 100, verde: 0, valorCafeKg: 36000, factorRendimiento: 94,
    trillaLavado: 600, trillaHoney: 750, trillaNatural: 1300, seleccion: 2300,
    tueste: 6000, empacarMolerSellar: 2000, costoBolsa: 2500, costoSticker: 1500,
    pesoFinalTostado: 64, gramajeBolsa: 300, transporteExtras: 100000,
    precioPublico: 36000, iva: 0.05, unidadesCortesia: 0
  };

  var inputs = {};
  root.querySelectorAll('[data-cf]').forEach(function (el) {
    inputs[el.getAttribute('data-cf')] = el;
  });

  function safeDiv(n, d) {
    if (!isFinite(n) || !isFinite(d) || d === 0) return 0;
    return n / d;
  }

  function money(v) {
    if (!isFinite(v)) v = 0;
    return '$' + Math.round(v).toLocaleString('es-CO');
  }

  function calculate(i) {
    var valorCarga = i.cps === 0 ? i.valorCafeKg * 93.1 : i.valorCafeKg * 125;
    var base = safeDiv(valorCarga, 93.1);
    var pkvLavado = base + i.trillaLavado + i.seleccion;
    var pkvHoney = base + i.trillaHoney + i.seleccion;
    var pkvNatural = base + i.trillaNatural + i.seleccion;
    var verdeEnKg = safeDiv((i.cps + i.verde) * 70, i.factorRendimiento);
    var pctTueste = verdeEnKg === 0 ? 0 : 1 - safeDiv(i.pesoFinalTostado, verdeEnKg);
    var denom = 1 - pctTueste;
    var pgtLavado = safeDiv(pkvLavado / 1000, denom);
    var pgtHoney = safeDiv(pkvHoney / 1000, denom);
    var pgtNatural = safeDiv(pkvNatural / 1000, denom);
    var costoBolsaTotal = i.costoSticker + i.costoBolsa + i.empacarMolerSellar;
    var tuestePorBolsa = (i.tueste / 1000) * i.gramajeBolsa;
    var ctLavado = pgtLavado * i.gramajeBolsa + costoBolsaTotal + tuestePorBolsa;
    var ctHoney = pgtHoney * i.gramajeBolsa + costoBolsaTotal + tuestePorBolsa;
    var ctNatural = pgtNatural * i.gramajeBolsa + costoBolsaTotal + tuestePorBolsa;
    var unidadesPorCarga = safeDiv(i.pesoFinalTostado * 1000, i.gramajeBolsa);
    var ivaPorBolsa = i.precioPublico - safeDiv(i.precioPublico, i.iva + 1);
    var totalUnidades = Math.max(0, Math.floor(unidadesPorCarga) - (i.unidadesCortesia || 0));
    var venta = i.precioPublico;

    function row(costoBase) {
      var cost = costoBase + ivaPorBolsa;
      return { cost: cost, sale: venta, profitPerUnit: venta - cost, totalProfit: (venta - cost) * totalUnidades };
    }

    return {
      valorCarga: valorCarga,
      verdeEnKg: verdeEnKg,
      pctTueste: pctTueste,
      unidadesPorCarga: unidadesPorCarga,
      totalVenta: venta * totalUnidades,
      lavado: row(ctLavado),
      honey: row(ctHoney),
      natural: row(ctNatural)
    };
  }

  function setOut(key, text) {
    var el = root.querySelector('[data-co="' + key + '"]');
    if (el) el.textContent = text;
  }

  function render() {
    var i = {};
    Object.keys(DEFAULTS).forEach(function (k) {
      var el = inputs[k];
      i[k] = el ? (parseFloat(el.value) || 0) : DEFAULTS[k];
    });
    var r = calculate(i);
    setOut('valorCarga', money(r.valorCarga));
    setOut('verdeEnKg', (Math.round(r.verdeEnKg * 10) / 10) + ' kg');
    setOut('pctTueste', (Math.round(r.pctTueste * 1000) / 10) + '%');
    setOut('unidadesPorCarga', String(Math.floor(r.unidadesPorCarga)));
    setOut('totalVenta', money(r.totalVenta));
    ['lavado', 'honey', 'natural'].forEach(function (p) {
      setOut(p + '.cost', money(r[p].cost));
      setOut(p + '.sale', money(r[p].sale));
      setOut(p + '.profitPerUnit', money(r[p].profitPerUnit));
      setOut(p + '.totalProfit', money(r[p].totalProfit));
    });
  }

  Object.keys(inputs).forEach(function (k) {
    inputs[k].addEventListener('input', render);
  });

  var reset = root.querySelector('[data-cfp-reset]');
  if (reset) {
    reset.addEventListener('click', function () {
      Object.keys(DEFAULTS).forEach(function (k) {
        if (inputs[k]) inputs[k].value = DEFAULTS[k];
      });
      render();
    });
  }

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capilla-header"]) return;
  try {
    
(function () {
  var header = document.querySelector('.cph--scroll');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 16);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var btn = document.querySelector('[data-cph-toggle]');
  var details = document.getElementById('Details-menu-drawer-container');
  if (btn && details) {
    var drawerPanel = document.getElementById('menu-drawer');

    function setDrawer(open) {
      details.open = open;
      btn.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('cph-drawer-open', open);
    }

    // Self-sufficient toggle: drive the native <details> directly. The drawer
    // is shown purely from the [open] state via CSS, so it does not depend on
    // Dawn's menu-drawer.js running.
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      setDrawer(!details.open);
    });

    // Close on Escape.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) setDrawer(false);
    });

    // Close when clicking outside the drawer panel and the burger.
    document.addEventListener('click', function (e) {
      if (!details.open) return;
      if (drawerPanel && drawerPanel.contains(e.target)) return;
      if (btn.contains(e.target)) return;
      setDrawer(false);
    });

    // Close when a real navigation link inside the drawer is followed.
    if (drawerPanel) {
      drawerPanel.addEventListener('click', function (e) {
        var a = e.target.closest('a[href]');
        if (a) setDrawer(false);
      });
    }

    // Keep aria + body lock in sync if the details is toggled elsewhere.
    details.addEventListener('toggle', function () {
      btn.setAttribute('aria-expanded', String(details.open));
      document.documentElement.classList.toggle('cph-drawer-open', details.open);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
